import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedDownFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.68 10.3C11.68 8.36 10.18 6.84 8.3 6.84H3.76V4.92H8.3C11.36 4.92 13.68 7.24 13.68 10.3V17.12L18.24 12.5L19.46 13.72L12.7 20.48L5.94 13.72L7.16 12.5L11.68 17.08V10.3Z" />
    </SvgIcon>
  );
});
